import { render, staticRenderFns } from "./FacturaSingle.vue?vue&type=template&id=4d0f4b0d&scoped=true&lang=pug"
import script from "./FacturaSingle.vue?vue&type=script&lang=js"
export * from "./FacturaSingle.vue?vue&type=script&lang=js"
import style0 from "./FacturaSingle.vue?vue&type=style&index=0&id=4d0f4b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f4b0d",
  null
  
)

export default component.exports